import React, { useState } from 'react'
import EmployeDashboardLayout from './EmployeDashboardLayout'
import DownloadButtons from '../../../components/downloadButtons/DownloadButtons';
import AllSettings from '../../../components/allSettings/AllSettings';

const EmployeeSettings = () => {

    const [showPass, setShowPass] = useState(false);
    const [changeCards, setChangeCards] = useState("")

    const passwordHideShow = () => {
        setShowPass(!showPass);
    }

    return (
        <>
            <EmployeDashboardLayout>
               <AllSettings/>
            </EmployeDashboardLayout>
        </>
    )
}

export default EmployeeSettings